import React from 'react'

import Navbar from 'react-bulma-components/lib/components/navbar'

import bto from './bto-logo-portrait.gif'
import logo from './logo.png'
import ukceh from './UKCEH-Logo.png'

function Nav () {
  return (
    <Navbar color='black' className='nav'>
      <Navbar.Brand>
        <Navbar.Item renderAs='div'>
          <img src={logo} alt='Assist Scenario Exploration Tool' height='53' width='302' />
        </Navbar.Item>
      </Navbar.Brand>
      <Navbar.Menu>
        <Navbar.Container position='end'>
          <Navbar.Item renderAs='div'>
            <img src={bto} alt='British Trust for Ornithology' />
          </Navbar.Item>
          <Navbar.Item renderAs='div'>
            <img src={ukceh} alt='UK Centre for Ecology & Hydrology' />
          </Navbar.Item>
        </Navbar.Container>
      </Navbar.Menu>
    </Navbar>
  )
}

export default Nav
